import axios, { AxiosResponse } from 'axios'
import { ID, Response } from '../../../../../_metronic/helpers'
import { configuration } from '../../../../../configuration'
const API_URL = configuration.apiUrl
const Party_URL = `${API_URL}/party/getPartyListing`
const PARTY_LISTING = `${API_URL}/party/v1/getPartyListing`


const Update_Party_URL = `${API_URL}/party/editParty`
const City_URL = `${API_URL}/city`
const PARTY_URL = `${API_URL}/party`
const GET_CITY_URL = `${API_URL}/party/cityListing`
const USER_URL = `${API_URL}/users/allUser`
// const getPartys = (query: string): Promise<any> => {
//   console.log(" QUERIES : --> ",query);
//   return axios.get(`${Party_URL}?${query}`).then((d: AxiosResponse<any>) => d.data)
// }

const getPartys = (query: string): Promise<any> => {
  const params = new URLSearchParams(query);

  // Extract sort and order values
  const sort = params.get("sort");
  const order = params.get("order")?.toUpperCase();

  // Remove sort and order from query params
  params.delete("sort");
  params.delete("order");

  // Append filter[orderBy] if sort and order exist
  if (sort && order) {
    params.set("filter[orderBy]", `${sort} ${order}`);
  }

  //console.log(" QUERIES : --> ", params.toString());

  return axios.get(`${Party_URL}?${params.toString()}`)
    .then((d: AxiosResponse<any>) => d.data);
};


const getPartyListing = (query: string): Promise<any> => {
  const params = new URLSearchParams(query);

  // Extract sort and order values
  const sort = params.get("sort");
  const order = params.get("order")?.toUpperCase();

  // Remove sort and order from query params
  params.delete("sort");
  params.delete("order");

  // Append filter[orderBy] if sort and order exist
  if (sort && order) {
    params.set("filter[orderBy]", `${sort} ${order}`);
  }
  // Rename page → offset and perPage → limit
  const page = (params.get("page")) || 1;
  // const limit = params.get("perPage") ?? 10;
  const perPage = (params.get("perPage")) || 10;
  // const offset = (page)  ; // Adjust offset calculation

  params.set("page", page.toString());
  params.set("perPage", perPage.toString());

  // params.delete("page");
  // params.delete("perPage");
  //console.log(" QUERIES : --> ", params.toString());

  return axios.get(`${PARTY_LISTING}?${params.toString()}`)
    .then((d: AxiosResponse<any>) => d.data);
};
const getParty = (query: string): Promise<any> => {
  return axios
    .get(`${Party_URL}?is_active=true&sort=party_name&order=ASC`)
    .then((d: AxiosResponse<any>) => d.data)
}

const getEditParty = (id: any): Promise<any> => {
  return axios
    .get(`${PARTY_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const getUsers = (query: string): Promise<any> => {
  return axios.get(`${USER_URL}?sort=name&order=ASC`).then((d: AxiosResponse<any>) => d.data)
}
const uniqueCode = (query: string): Promise<any> => {
  return axios
    .get(`${Party_URL}/uniqueCode?party_code=${query}`)
    .then((d: AxiosResponse<any>) => d.data)
}
const getCities = (): Promise<any> => {
  return axios.get(`${GET_CITY_URL}`).then((d: AxiosResponse<any>) => d.data)
}

const getPartyById = (id: any): Promise<any> => {
  return axios
    .get(`${Party_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

//Changes here
const createParty = (data: any): Promise<any> => {
  return axios.post(`${PARTY_URL}/addParty`, data).then((response: AxiosResponse<Response<any>>) => response)
}

const createCity = (data: any): Promise<any> => {
  return axios.post(`${City_URL}/addCity`, data).then((response: AxiosResponse<Response<any>>) => response)
}

const updateParty = (data: any, id: any): Promise<any> => {
  return axios
    .put(`${Update_Party_URL}/${id}`, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteParty = (id: any): Promise<any> => {
  return axios
    .delete(`${Party_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const DeviceTokenReset = (id: any): Promise<any> => {
  return axios
    .delete(`${Party_URL}/deviceTokenReset/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteSelectedPartys = (PartyIds: Array<ID>): Promise<void> => {
  const requests = PartyIds.map((id) => axios.delete(`${Party_URL}/${id}`))
  return axios.all(requests).then(() => { })
}

export {
  getEditParty,
  createParty,
  getPartyListing,
  deleteParty,
  deleteSelectedPartys,
  getPartyById,
  getPartys,
  updateParty,
  createCity,
  getCities,
  DeviceTokenReset,
  uniqueCode,
  getUsers,
  getParty,
}
